import PropTypes from 'prop-types';
// material-ui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project imports
import MainCard from 'components/MainCard';

// ==============================|| REPORT CARD ||============================== //


export default function ReportCard({ primary, secondary, iconPrimary, color, extraInfo }) {
  const IconPrimary = iconPrimary;
  const primaryIcon = iconPrimary ? <IconPrimary fontSize="large" /> : null;

  return (
    <MainCard sx={{ height: '100%' }}>
      {/* Keep the icon beside the text: in narrow columns a long label wraps instead of
          pushing the icon onto its own line, so cards in a row stay the same height. */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1.5}>
        <Stack spacing={1} sx={{ minWidth: 0 }}>
          <Typography variant="h4">{primary}</Typography>
          {extraInfo && (
            <Typography variant="body2" color="textSecondary" sx={{ mt: -0.5 }}>
              {extraInfo}
            </Typography>
          )}
          <Typography variant="body1" color="secondary">
            {secondary}
          </Typography>
        </Stack>
        {primaryIcon && (
          <Typography variant="h2" component="span" sx={{ color, display: 'flex', flexShrink: 0 }}>
            {primaryIcon}
          </Typography>
        )}
      </Stack>
    </MainCard>
  );
}

ReportCard.propTypes = { primary: PropTypes.any, secondary: PropTypes.any, iconPrimary: PropTypes.any, color: PropTypes.any, extraInfo: PropTypes.any };
